export default __webpack_public_path__ + "static/media/verizon.1f14fdcb.svg";